import styled from "styled-components"

const StyledContainer = styled.div`
  max-width: var(--max-width);  {/* if this object would render wider than what max-width says it can be, max-width
                                    wins */}
  margin: 0 auto;               {/* this object will set centrally within it's parent container */}
  padding: 0 .75rem;            
  
  @media screen and (max-width: 479px) {
    padding: 0 .5rem;
  }
`

export default StyledContainer;
